<div class="absolute top-0 right-0 bottom-0 left-0"></div>

@let _dimension = dimension();
@if (_dimension) {
  <shared-dp-text-selection-overlay
    [selectedWordsRect]="selectedWordRects()"
    [lasso]="boxSelection.currentLasso()"
    [dimension]="_dimension"
    [showTextSelectionOverlay]="true" />
}
